import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

export const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, setLanguage } = useLanguage();

  return (
    <ButtonGroup size="small" variant="outlined">
      <Button
        onClick={() => setLanguage('en')}
        variant={currentLanguage === 'en' ? 'contained' : 'outlined'}
      >
        En
      </Button>
      <Button
        onClick={() => setLanguage('hi')}
        variant={currentLanguage === 'hi' ? 'contained' : 'outlined'}
      >
        हिं
      </Button>
    </ButtonGroup>
  );
};
